/* Customer stories (sections/st-stories.liquid; v5 #stories).
   - Pressing a story swaps its poster for the video with controls, playing with sound, and pauses
     any other story that was playing. Focus moves to the video.
   - Muted previews: the story nearest the middle of the screen, or the one under a fine pointer,
     plays silently on a loop with a "Muted preview" tag. One at a time; it stops when the page is
     hidden. Not under reduced motion, data saver, or without IntersectionObserver. */
(() => {
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const save = navigator.connection && navigator.connection.saveData;

  const init = (rail) => {
    if (rail.dataset.stReady) return;
    rail.dataset.stReady = '1';
    const items = [...rail.querySelectorAll('.st-story__media[data-video]')];

    items.forEach((b) => {
      b.addEventListener('click', () => {
        if (b.classList.contains('is-playing')) return;
        stop(b);
        rail.querySelectorAll('.st-story__media.is-playing video').forEach((v) => v.pause());
        const v = document.createElement('video');
        v.src = b.dataset.video;
        v.controls = true;
        v.playsInline = true;
        v.autoplay = true;
        const poster = b.querySelector('.st-story__poster');
        if (poster) v.poster = poster.currentSrc || poster.src;
        const holder = document.createElement('div');
        holder.className = 'st-story__media is-playing';
        holder.appendChild(v);
        b.replaceWith(holder);
        if (cur === b) cur = null;
        v.focus();
        v.play()?.catch(() => {});
      });
    });

    let cur = null;
    const stop = (b) => {
      if (!b) return;
      const v = b.querySelector('video.st-story__pv');
      if (v) {
        v.pause();
        v.classList.remove('is-on');
      }
      b.classList.remove('is-previewing');
    };
    if (RM || save || !('IntersectionObserver' in window)) return;

    const vis = new Map();
    let hover = null;
    items.forEach((b) => {
      const tag = document.createElement('span');
      tag.className = 'st-story__muted';
      tag.setAttribute('aria-hidden', 'true');
      tag.textContent = rail.dataset.muted || '';
      b.appendChild(tag);
    });
    const preview = (b) => {
      let v = b.querySelector('video.st-story__pv');
      if (!v) {
        v = document.createElement('video');
        v.className = 'st-story__pv';
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.loop = true;
        v.preload = 'auto';
        v.setAttribute('aria-hidden', 'true');
        v.src = b.dataset.video;
        v.addEventListener('playing', () => v.classList.add('is-on'));
        b.insertBefore(v, b.firstChild);
      }
      return v;
    };
    const play = (b) => {
      if (b === cur) return;
      stop(cur);
      cur = b;
      if (!b || !b.isConnected) return;
      const v = preview(b);
      b.classList.add('is-previewing');
      v.play()?.catch(() => b.classList.remove('is-previewing'));
    };
    const pick = () => {
      if (hover && hover.isConnected) return play(hover);
      let best = null;
      let bd = Infinity;
      const cx = window.innerWidth / 2;
      const cy = window.innerHeight / 2;
      vis.forEach((r, b) => {
        if (r < 0.6 || !b.isConnected) return;
        const rc = b.getBoundingClientRect();
        const d = Math.abs(rc.left + rc.width / 2 - cx) + Math.abs(rc.top + rc.height / 2 - cy) * 0.5;
        if (d < bd) {
          bd = d;
          best = b;
        }
      });
      play(best);
    };
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((x) => (x.isIntersecting ? vis.set(x.target, x.intersectionRatio) : vis.delete(x.target)));
        pick();
      },
      { threshold: [0, 0.6, 0.9, 1] }
    );
    items.forEach((b) => {
      io.observe(b);
      if (FINE) {
        b.addEventListener('pointerenter', () => {
          hover = b;
          pick();
        });
        b.addEventListener('pointerleave', () => {
          hover = null;
          pick();
        });
      }
    });
    let tick = false;
    rail.addEventListener(
      'scroll',
      () => {
        if (tick) return;
        tick = true;
        requestAnimationFrame(() => {
          tick = false;
          pick();
        });
      },
      { passive: true }
    );
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop(cur);
        cur = null;
      } else pick();
    });
  };
  const run = () => document.querySelectorAll('[data-st-stories]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
